import { render } from "./AccountNew.vue?vue&type=template&id=92fc40ba&ts=true"
import script from "./AccountNew.vue?vue&type=script&lang=ts"
export * from "./AccountNew.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__